import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import FavIcon from '@material-ui/icons/FavoriteBorderOutlined';

import classes from '../../css/getCSS';

const partnerChoice = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('partnerchoice')}>Edit</Button>
    );
  }
  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <FavIcon className={classes.titleIcon} />
          {'Partner\'s Choice'}
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Age</p>
            <p className={classes.profileVal}>
              From: {props.profile.partnerchoice.from_age}&nbsp;
              To: {props.profile.partnerchoice.to_age}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Height.</p>
            <p className={classes.profileVal}>
              From: {props.profile.partnerchoice.from_height}&nbsp;
              To: {props.profile.partnerchoice.to_height}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Marital Status</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.marital_status ? props.profile.partnerchoice.marital_status : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Caste</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.caste ? props.profile.partnerchoice.caste : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Qualification</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.qualification ? props.profile.partnerchoice.qualification : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Degree</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.degree ? props.profile.partnerchoice.degree : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Profession</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.profession ? props.profile.partnerchoice.profession : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Work Profile</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.work_profile ? props.profile.partnerchoice.work_profile : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Income</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.income ? props.profile.partnerchoice.income : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Diet</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.diet
                ? props.profile.partnerchoice.diet.label
                : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Smoke</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.smoke
                ? props.profile.partnerchoice.smoke.label
                : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Drink</p>
            <p className={classes.profileVal}>
              {props.profile.partnerchoice.drink
                ? props.profile.partnerchoice.drink.label
                : 'Any'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Horoscope Required?</p>
            <p className={classes.profileVal}>{props.profile.partnerchoice.horoscope}</p>
            <br />
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default partnerChoice;



// WEBPACK FOOTER //
// ./src/profile/components/PartnerChoice.js